import { EventListeners, MinzeElement } from 'minze'
import { config, Font } from '../../constants'
import { Locale } from '../../modules/locale'
import { getCardPlaceholder } from '../../modules/utils'
import MainModule from '../../modules/main'

Locale.getInstance().registerKeySet('fr', 'lvcEventCard', {
  cancelledLabel: 'Annulé',
  postponedLabel: 'Reporté',
  rescheduledLabel: 'Nouvelle date!',
  cancelledTooltip: `Cette représentation a été annulée.<br/>Pour plus de détails, contactez la billeterie.`,
  postponedTooltip: `Cette représentation a été reportée.<br/>La nouvelle date sera fournie sous peu.`,
  rescheduledTooltip: `Les dates de cet événement ont changées.<br/>Dates précédentes :`,
})
Locale.getInstance().registerKeySet('en', 'lvcEventCard', {
  cancelledLabel: 'Cancelled',
  postponedLabel: 'Postponed',
  rescheduledLabel: 'New date!',
  cancelledTooltip: `This performance has been cancelled.<br/>For more details, contact the box office.`,
  postponedTooltip: `This performance has been postponed.<br/>The new date will be announced shortly.`,
  rescheduledTooltip: `The dates for this event have changed.<br/>Previous dates:`,
})

export class LvcEventCard extends MinzeElement {
  attrs = [
    'data-schema',
    'data-formatted-date',
    'data-start-time',
    'data-event-id',
    'data-event-url',
    'data-image-url',
    'data-image-alt',
    'data-location',
    'data-status-flag',
    'data-status-flag-text',
    'data-status',
    'data-gtm-id',
    'data-gtm-name',
    'data-gtm-brand',
    'data-gtm-category',
    'data-gtm-category2',
    'data-gtm-category3',
    'data-gtm-category4',
    'data-gtm-index',
    'data-gtm-list-name',
    'data-search-card-mode',
    'data-tag',
  ]

  onLinkClicked = (event: Event) => {
    event.preventDefault()

    let el = event?.target as HTMLElement
    if (!el) return

    if (
      el.tagName !== 'LVC-FAVORITE-BUTTON' &&
      el.tagName !== 'LVC-TAGS' &&
      el.tagName !== 'LVC-FAVORITE-ICON-BUTTON'
    ) {
      const linkEl = el.closest('a')
      if (!linkEl) return
      if (this.dataSchema !== 'artist' && this.dataSchema !== 'places') {
        window.dataLayer = window.dataLayer || []
        window.dataLayer.push({
          event: 'select_item',
          ecommerce: {
            items: [
              {
                item_id: linkEl.getAttribute('data-gtm-id') || '',
                item_name: linkEl.getAttribute('data-gtm-name') || '',
                item_brand: linkEl.getAttribute('data-gtm-brand') || '',
                item_category: linkEl.getAttribute('data-gtm-category') || '',
                item_category2: linkEl.getAttribute('data-gtm-category2') || '',
                item_category3: linkEl.getAttribute('data-gtm-category3') || '',
                item_category4: linkEl.getAttribute('data-gtm-category4') || '',
                item_list_name: linkEl.getAttribute('data-gtm-list-name') || '',
                index: linkEl.getAttribute('data-gtm-index') ?? '',
              },
            ],
          },
        })
      }
      MainModule.getInstance().storeEventClickedFromList({
        listName: linkEl.getAttribute('data-gtm-list-name') || '',
        index: linkEl.getAttribute('data-gtm-index') || '',
      })
      window.location.href = linkEl.getAttribute('href') || ''
    }
  }

  html = () => `
    <div class="event_similar-event-component ${this.dataStatus === 'Postpone' ? 'postponed' : ''} ${this.dataStatus === 'Cancelled' ? 'disabled' : ''}">
      <a
        href="${this.dataEventUrl}"
        class="event_similar-event-item w-inline-block"
        data-gtm-id="${this.dataEventId || ''}"
        data-gtm-name="${this.dataGtmName || ''}"
        data-gtm-brand="${this.dataGtmBrand || ''}"
        data-gtm-category="${this.dataGtmCategory || ''}"
        data-gtm-category2="${this.dataGtmCategory2 || ''}"
        data-gtm-category3="${this.dataGtmCategory3 || ''}"
        data-gtm-category4="${this.dataGtmCategory4 || ''}"
        data-gtm-index="${this.dataGtmIndex || ''}"
        data-gtm-list-name="${this.dataGtmListName || ''}"
      >
        <div class="event_similar-event-content">
          <div class="event_similar-event-info-content">
            ${
              this.dataStatusFlag && this.dataStatusFlagText
                ? `
              <div class="event-status-badge"><p>${this.dataStatusFlagText}</p></div>
            `
                : ''
            }
            <h4 
              data-ihtml-ref="nameFr" 
              data-bbd="true" 
              data-bbd-rh="innerHTML" 
              class="event_similar-event-title text-style-2lines"
            >
              <slot name="title"></slot>
            </h4>
            <h3 class="event_subtitle text-style-2lines">
              <slot name="subtitle"></slot>
            </h3>
            ${
              this.dataFormattedDate || this.dataStartTime || this.dataLocation
                ? `
              <div class="event_similar-event-info-wrapper">
                ${
                  this.dataFormattedDate
                    ? `
                  <div class="event_similar-event-date-time-wrapper">
                    <div class="event_similar-event-date-time-item">
                      <div class="event_similar-event-info-icon">
                        <lvc-calendar-icon></lvc-calendar-icon>
                        ${
                          this.dataStatus === 'Postpone' ||
                          this.dataStatus === 'Cancelled' ||
                          this.dataStatus === 'Rescheduled'
                            ? `
                          <div class="info-icon">
                            <lvc-info-icon></lvc-info-icon>
                            <div class="info-tooltip">
                              ${Locale.getKey(
                                this.dataStatus === 'Postpone'
                                  ? 'lvcEventCard.postponedTooltip'
                                  : this.dataStatus === 'Rescheduled'
                                    ? 'lvcEventCard.rescheduledTooltip'
                                    : 'lvcEventCard.cancelledTooltip'
                              )} ${this.dataStatus === 'Rescheduled' ? this.dataFormattedDate : ``}
                            </div>
                          </div>
                        `
                            : ''
                        }
                      </div>
                      <div data-ihtml-ref="startDateFormatted" data-bbd="true" data-bbd-rh="innerHTML" class="event_similar-event-info-text">
                        <slot name="date"></slot>
                      </div>
                    </div>
                  </div>
                `
                    : ''
                }
                ${
                  this.dataStartTime && this.dataStartTime !== true
                    ? `
                <div class="event_similar-event-location-wrapper">
                  <div class="event_similar-event-info-icon">
                    <lvc-clock-icon></lvc-clock-icon>
                  </div>
                  <div data-ihtml-ref="location" data-bbd="true" data-bbd-rh="innerHTML" class="event_similar-event-info-text">
                    <slot name="start-time"></slot>
                  </div>
                </div>
                `
                    : ''
                }  
                ${
                  this.dataLocation && this.dataStartTime !== true
                    ? `
                    <div class="event_similar-event-location-wrapper">
                      <div class="event_similar-event-info-icon">
                        <lvc-pin-icon></lvc-pin-icon>
                      </div>
                      <div data-ihtml-ref="location" data-bbd="true" data-bbd-rh="innerHTML" class="event_similar-event-info-text">
                        <slot name="location"></slot>
                      </div>
                    </div>
                  `
                    : ``
                }
              </div>
            `
                : ''
            }
            ${this.dataSchema === 'artist' ? `<slot name="event-count"></slot>` : ''}
            ${
              this.dataTag
                ? `
              <lvc-box mt="10px" class="tags-container">
                <lvc-tags data-size="small" data-discipline-tags="${this.dataTag}"></lvc-tags>
              </lvc-box>
            `
                : ''
            }
          </div>
          <div class="event_similar-event-image-wrapper">
            ${
              this.dataStatus === 'Rescheduled'
                ? `
              <div class="rescheduled-badge">
                ${Locale.getKey('lvcEventCard.rescheduledLabel')}
              </div>
            `
                : ''
            }
            ${
              this.dataStatus === 'Postpone'
                ? `
              <div class="postponed-badge">
                <lvc-reported-icon></lvc-reported-icon>
                ${Locale.getKey('lvcEventCard.postponedLabel')}
              </div>
            `
                : ''
            }
            ${
              this.dataStatus === 'Cancelled'
                ? `
              <div class="cancelled-badge">
                <lvc-sad-charlie-face-icon></lvc-sad-charlie-face-icon>
                ${Locale.getKey('lvcEventCard.cancelledLabel')}
              </div>
            `
                : ''
            }
            <lvc-image 
              slot="image"
              src="${this.dataImageUrl || getCardPlaceholder((this?.dataSchema as string) || '')}"
              data-image-placeholder="${getCardPlaceholder((this?.dataSchema as string) || '')}"
              alt="${this.dataImageAlt}"
            ></lvc-image>
            <lvc-favorite-icon-button
              data-id="${this.dataEventId}"
              data-type="${this.dataSchema}"
              data-gtm-id="${this.dataEventId}"
              data-gtm-name="${this.dataGtmName}"
              data-gtm-brand="${this.dataGtmBrand}"
              data-gtm-category="${this.dataGtmCategory}"
              data-gtm-category2="${this.dataGtmCategory2}"
              data-gtm-category3="${this.dataGtmCategory3}"
              data-gtm-category4="${this.dataGtmCategory4}"
            >
            </lvc-favorite-icon-button>
          </div>
        </div>
      </a>
    </div>
  `

  css = () => `
    lvc-favorite-icon-button {
      position: absolute;
      top: 4px;
      right: 3px;
    }
    .event_similar-event-component {
      grid-column-gap: 20px;
      grid-row-gap: 20px;
    }
    
    a {
      color: #1e007d;
      font-size: 0.875rem;
      text-decoration: underline;
    }
    
    .event_similar-event-item {
      display: block;
      padding-top: 20px;
      padding-bottom: 20px;
      justify-content: space-between;
      text-decoration: none;
    }
    
    .event_subtitle {
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: 150%;
      margin: 5px 0 -5px;
    }
    
    .event_similar-event-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    
    .event_similar-event-info-icon {
      position: relative;
    }
    
    .event_similar-event-component.disabled .event_similar-event-title,
    .event_similar-event-component.disabled .event_similar-event-image-wrapper >*:not(.cancelled-badge),
    .event_similar-event-component.disabled .event_similar-event-info-text,
    .event_similar-event-component.disabled .event_subtitle,
    .event_similar-event-component.disabled .tags-container,
    .event_similar-event-component.disabled .event_similar-event-info-icon >*:not(.info-icon) {
      opacity: 0.5;
    }
    
    .info-icon {
      position: absolute;
      top: -5px;
      right: -5px;
    }
    
    .info-icon:hover .info-tooltip {
      display: block;
    }
    
    .info-tooltip {
      display: none;
      position: absolute;
      border: 1px solid #1E007D4D;
      background: white;
      border-radius: 8px;
      z-index: 1;
      padding: 16px;
      width: max-content;
    }
    
    .event_similar-event-component.disabled .event_similar-event-date-time-wrapper .event_similar-event-info-text,
    .event_similar-event-component.postponed .event_similar-event-date-time-wrapper .event_similar-event-info-text {
      text-decoration: line-through;
    }
    
    .event_similar-event-component.disabled lvc-favorite-button {
      display: none;
    }
    
    .event_similar-event-info-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }
    
    .event_similar-event-info-content.disabled {
      opacity: 0.5;
    }
    
    .event_similar-event-image-wrapper {
      width: 188px;
      flex: 0 0 auto;
      position: relative;
    }
    
    .cancelled-badge, .postponed-badge, .rescheduled-badge {
      background: #FF4600;
      position: absolute;
      top: -3px;
      left: -3px;
      z-index: 1;
      display: flex;
      align-items: center;
      padding: 8px;
      gap: 10px;
      border-radius: 4px;
      color: #14141E;
    }
    
    .postponed-badge {
      background: #FFB201;
    }
    
    .rescheduled-badge {
      background: #DCFFD7;
    }
    
    .cancelled-badge lvc-sad-charlie-face-icon {
      height: 21px;
    }
    
    .postponed-badge lvc-reported-icon {
      height: 24px;
    }
    
    slot {
      pointer-events: none;
    }
    
    .event_similar-event-title {
      font-weight: ${Font.weight.extraBold};
      margin-top: 0rem;
      margin-bottom: 0rem;
      font-size: 1.5rem;
      line-height: ${this.dataSearchCardMode ? '1.2' : '1.4'};
      text-transform: uppercase;
    }
    
    .event_similar-event-info-wrapper {
      display: flex;
      flex-direction: ${this.dataSearchCardMode ? 'row' : 'column'};
      margin-top: 10px;
      margin-bottom: ${this.dataSearchCardMode ? '0px' : '14px'};
      flex-wrap: wrap;
      align-items: flex-start;
      grid-column-gap: ${this.dataSearchCardMode ? '30px' : '2.5rem'};
      grid-row-gap: 8px;
    }
    
    .event_similar-event-date-time-wrapper {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      grid-column-gap: 1.2rem;
      grid-row-gap: 4px;
    }
    
    .event_similar-event-date-time-item {
      display: flex;
      align-items: center;
      grid-column-gap: 8px;
      grid-row-gap: 8px;
    }
    
    .event_similar-event-info-icon {
      width: 24px;
      height: 24px;
    }
    
    .event_similar-event-info-text {
      font-size: 14px;
    }
    
    .event_similar-event-location-wrapper {
      display: flex;
      align-items: center;
      grid-column-gap: 8px;
      grid-row-gap: 8px;
    }
    
    .event-status-badge {
      background-image: url(${config.images.eventStatusLabelMask});
      background-position: 50%;
      background-repeat: no-repeat;
      background-size: cover;
      background-attachment: scroll;
      border-radius: 2px;
      padding: 12px;
      color: #1E007D;
      font-weight: ${Font.weight.medium};
      font-size: 14px;
      line-height: 150%;
      position: relative;
      margin-bottom: 12px;
    }
    
    .event-status-badge p {
      margin: 0;
      position: relative;
      z-index: 1;
    }
    
    .text-style-2lines {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    
    @media screen and (max-width: 730px) {
      .event_similar-event-item {
        padding: 16px 0 4px 0;
      }
      .event_similar-event-info-content {
        order: 1;
      }
      .event_similar-event-content {
        align-items: flex-start;
        justify-content: normal;
        gap: 16px;
      }
      .event_similar-event-info-wrapper {
        flex-direction: column;
        gap: 6px;
        margin: 8px 0;
      }
      .event_similar-event-image-wrapper {
        width: 40%;
      }
      .event_similar-event-title {
        font-size: 18px;
        line-height: 120%;
      }
      .event_similar-event-info-text {
        font-size: 11px;
        line-height: 120%;
      }
      lvc-favorite-button {
        display: none;
      }
    }
  `

  eventListeners: EventListeners = [['.event_similar-event-item', 'click', this.onLinkClicked]]
}
